export default class NengiCommand {
  static protocol: any;
}
